import { Button, Input, Modal, Table } from "antd";
import React from "react";

export default function AddFromPMSModal({
  saveTreatmentPlanToServer,
  setSelectedRowKeys2,
  selectedRowKeys2,
  isModalVisible3,
  handleCancel3,
  selectModal,
  pmsColumns,
  setSearch,
  record,
  pms,
}) {
  return (
    <Modal
      title={selectModal ? "Treatments Pulled from PMS" : "PMS Data Preview"}
      open={isModalVisible3}
      centered
      width={950}
      style={{ width: 1024, height: 900 }}
      footer={null}
      onCancel={() => handleCancel3()}
    >
      {selectModal ? (
        <>
          <p style={{ color: "#848696" }}>You can select Procedures and add to selected Treatment.</p>
          <Input
            style={{ width: "100%", height: 43, borderRadius: 8, border: "1px solid #6B43B5" }}
            placeholder="Search Procedures"
            onChange={(e) => setSearch(e.target.value)}
          />
          <Table
            columns={pmsColumns}
            dataSource={pms}
            rowKey="id" // Unique key for each row (assuming your data has a unique 'id' field)
            pagination={false}
            size="small"
            scroll={{ x: "max-content" }}
            style={{ border: "none", marginTop: 20 }}
            rowSelection={{
              type: "checkbox", // Allow multi-row selection
              selectedRowKeys: selectedRowKeys2,
              onChange: (newSelectedRowKeys) => setSelectedRowKeys2(newSelectedRowKeys),
            }}
          />
          <Button
            type="primary"
            style={{ marginTop: 35, width: "100%", height: 45, borderRadius: 50 }}
            onClick={() => saveTreatmentPlanToServer(record, record.key)}
            disabled={(pms && pms.length === 0) || selectedRowKeys2.length === 0} // Disable if there is no data (pms) or no pms is selected
          >
            Add to Treatment
          </Button>
        </>
      ) : (
        <Table
          columns={pmsColumns}
          dataSource={pms}
          rowKey="id"
          pagination={false}
          style={{ marginTop: 20 }}
          size="small"
          scroll={{ x: "max-content" }}
        />
      )}
    </Modal>
  );
}
